import { all } from "redux-saga/effects";

import creditSagas from "./credit";

export default function* ordersSagas() {
  yield all([creditSagas()]);
}
